/**
 * Estado inicial para auth resource
 */
export interface AuthState {
  isInitialized: boolean;
  isNewUser: boolean | null;
  needsProfileCompletion: boolean;
}

/**
 * Inicializador para auth state
 */
export const initialAuthState: AuthState = {
  isInitialized: false,
  isNewUser: null,
  needsProfileCompletion: false,
};
